import {
  ADD_NOTIFICATION,
  EDIT_NOTIFICATION,
  GET_NOTIFICATIONS,
  GET_NOTIFICATION_BY_ID,
  REMOVE_NOTIFICATION,
} from "../actions/notification-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const notificationReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_NOTIFICATION.REQUEST,
    GET_NOTIFICATIONS.REQUEST,
    GET_NOTIFICATION_BY_ID.REQUEST,
    EDIT_NOTIFICATION.REQUEST,
    REMOVE_NOTIFICATION.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_NOTIFICATION.SUCCESS,
    GET_NOTIFICATIONS.SUCCESS,
    GET_NOTIFICATION_BY_ID.SUCCESS,
    EDIT_NOTIFICATION.SUCCESS,
    REMOVE_NOTIFICATION.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_NOTIFICATION.FAILURE,
    GET_NOTIFICATIONS.FAILURE,
    GET_NOTIFICATION_BY_ID.FAILURE,
    EDIT_NOTIFICATION.FAILURE,
    REMOVE_NOTIFICATION.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { notificationReducer };
